import { create } from "zustand";

interface Props {
  activeTab: string;
  setActiveTab: (value: string) => void;
  isFetching: boolean;
  setIsFetching: (isFetching: boolean) => void;
}
const useInterfaceStore = create<Props>((set) => ({
  activeTab: "",
  setActiveTab: (activeTab) => set({ activeTab }),
  isFetching: false,
  setIsFetching: (isFetching) => set({ isFetching }),
}));

export default useInterfaceStore;
